<template>
<q-layout view="hHh Lpr fFf">
  <!-- header section -->
  <MainHeader @menu-button-clicked="toggleSideNav" />
  <SidebarNav ref="sidenav" />
  <OfflineIndicator />
  <!-- main section -->
  <q-page-container>
    <div v-if="bootstrapping" class="bootstrapping">
      <q-spinner size="48px" color="primary" />
    </div>
    <router-view v-slot="{ Component, route }" v-else>
      <transition name="fade" mode="out-in">
        <div :key="route.fullPath">
          <component :is="Component" />
        </div>
      </transition>
    </router-view>
  </q-page-container>
</q-layout>
</template>

<script>
import { ref } from 'vue'
import SidebarNav from '@/components/SidebarNav.vue'
import MainHeader from '@/components/MainHeader.vue'
import OfflineIndicator from '@/components/OfflineIndicator.vue'
import { useAppStore } from "@/stores/application.js"
import { useUserStore } from "@/stores/user.js"
import { refreshAccessToken } from "@/api"
import { storeToRefs } from 'pinia'
import { signalAuthInitReady } from "@/router"

export default {
  components: {
    SidebarNav,
    MainHeader,
    OfflineIndicator
  },
  setup() {
    const appStore = useAppStore()
    const userStore = useUserStore()
    const { darkMode } = storeToRefs(appStore)
    const bootstrapping = ref(true)

    async function initAuth() {
      if (!userStore.authenticated) {
        try {
          await refreshAccessToken()
        } catch {
          // No valid refresh cookie — stay logged out
        }
      }
      userStore._authInitialized = true
      signalAuthInitReady()
      bootstrapping.value = false
    }

    initAuth()

    return {
      darkMode,
      bootstrapping
    }
  },
    mounted() {
            this.$q.dark.set(this.darkMode)
    },
    watch: {
        darkMode(){
            this.$q.dark.set(this.darkMode)
        }
    },
  methods: {
    toggleSideNav(){
      this.$refs.sidenav.toggleSideNavigation()
    }
  }
}
</script>


<style lang="scss">

html {
  overscroll-behavior: none;
}
body.body--dark {
    color: #f0f0f0;
}
body.body--light {
    background: #f5fbff;
    color: #0f0f0f;
}
.q-menu--dark {
    background: #2c3c57 !important;
    box-shadow: none !important;
}

/* Route transition: fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.bootstrapping {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

@media (prefers-reduced-motion: reduce) {
  .fade-enter-active,
  .fade-leave-active {
    transition: none;
  }
}
</style>
